<template>
  <div @click="gotoDiagram" class="item-container">
    <div class="img-container c-img-container">
      <img @load="calculateImg" alt="pic" v-if="getImg" :src="getImg" />
      <div class="enlarge-icon" v-if="getImg">
        <EnlargeIcon @click.stop="onImgClick" />
      </div>
      <div v-if="!getImg" class="no-img">{{ $t('common.no_img') }}</div>
    </div>

    <div class="item-info">
      <div class="j-content part-name j-might-overflow">
        {{ item.partName ? $t(item.partName) : '' }}
        <!-- {{ item.modelNum ? `(${item.modelNum})` : '' }} -->
      </div>
    </div>

    <PreviewImageModal
      @after-close="handleAfterClose"
      v-if="showPreviewModal"
      :images="previewImg"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';

interface CatalogueItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'CatalogueItem',
  components: {
    EnlargeIcon,
    PreviewImageModal
  },
  data(): CatalogueItemProps {
    return {
      baseFileUrl,
      showPreviewModal: false,
      previewImg: []
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    model: {
      type: String,
      default: ''
    },
    vehicleId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0 && partsImgs[0].fileUrl) {
        res = baseFileUrl + partsImgs[0].fileUrl;
      }

      return res;
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.c-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    onImgClick() {
      this.previewImg.push(this.getImg);
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    gotoDiagram() {
      this.$router.push(
        `/diagram/${this.item.id}/${this.vehicleId}?model=${this.model ||
          ''}&partName=${this.item.partName}`
      );
    }
  }
});
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1px;
  border: 1px solid $secondary-color2;

  .item-info {
    background-color: $secondary-color1;
    padding: 14.5px 20px;

    .part-name {
      font-weight: bold;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &:hover {
    border: 1px solid $primary-color;
    transition: border 0.5s;

    .item-info {
      transition: all 0.5s;
      background-color: $primary-color;
      .part-name {
        color: white;
      }
    }
  }

  .img-container {
    cursor: pointer;
    position: relative;

    .enlarge-icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .no-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
